import { render, staticRenderFns } from "./DashboardEnergyConsumption.vue?vue&type=template&id=79f482d1&scoped=true&"
import script from "./DashboardEnergyConsumption.vue?vue&type=script&lang=js&"
export * from "./DashboardEnergyConsumption.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEnergyConsumption.vue?vue&type=style&index=0&id=79f482d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f482d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
